import React, { useState, useEffect,useContext } from "react";
import { trackPromise } from "react-promise-tracker";
import { customFormDataPost, customFetch } from '../../helper/api-helper/apiHerlpers';
import { ReactSortable } from "react-sortablejs";
import $ from 'jquery';
import apiUrls from '../../constants/apiUrls';
import commonParams from '../../constants/apiCommonParams';
import apis from '../../services/apis';
import { getTaskList } from "../../helper/context/actions";
import { toast } from "react-toastify";
import { useSmarkDispatch } from "../../Context/KeycloakContext";
import { Link } from 'react-router-dom';
import './userStory.css';
import { format } from "react-string-format";
import AppContext from "../../Context/AppContext";

const UserStory = (props) => {
    const dispatch = useSmarkDispatch();
    const storedToken = localStorage.getItem('keycloakToken');
    const { applicationId, siteId } = useContext(AppContext);
    const [userStories, setUserStories] = useState([]);
    const [isOpened, setIsOpened] = useState(false);

    const { masterProjectId, masterReleaseId, masterFeatureId } = props.header_data;

    useEffect(() => {
        fetchUserStories();
        
    }, [masterProjectId, masterReleaseId, masterFeatureId]);

    const fetchUserStories = async () => {
        if (!masterProjectId) {
            setUserStories([]);
            return;
        }

        setUserStories([]); 

        try {
            
            if (masterFeatureId) {
                const releaseId = masterReleaseId || 0; 
                await fetchFeatureStories(masterProjectId, releaseId, masterFeatureId);
                return;
            }

            
            if (masterReleaseId) {
                const response = await apis.getUserStories(applicationId, siteId,masterReleaseId, storedToken);
                setUserStories(response?.userStoryDetailList || []);
                return;
            }

            
            if (masterProjectId) {
                const response = await apis.getAllUserStoriesByProject(
                    applicationId,
                    siteId,
                    masterProjectId,
                    storedToken
                );

                
                if (response?.userStoryDetailList?.length) {
                    setUserStories(response.userStoryDetailList);
                } else {
                    setUserStories([]);
                }
                return;
            }



            setUserStories([]);
        } catch (err) {
            console.error(err);
            setUserStories([]);
        }
    };

   const fetchFeatureStories = async (projectId, releaseId = 0, featureId) => {
  try {
    const url = format(
      apiUrls.featureStories,
      applicationId,
      siteId,
      projectId,
      releaseId,
      featureId
    );

    const response = await customFetch(url, storedToken);

    if (!response?.json) {
      setUserStories([]);
      return;
    }

    const parsedResponse =
      typeof response.json === "string"
        ? JSON.parse(response.json)
        : response.json;

    setUserStories(parsedResponse?.userStoryDetailList || []);
  } catch (err) {
    console.error(err);
    setUserStories([]);
  }
};


   
    const toggleStoryTasks = (event) => {
        const storyTasks = $(event.target).hasClass("show-hide-task") ? $(event.target).next() : $(event.target).parent().next();
        storyTasks.toggleClass('task-details-collapse')
        setIsOpened(isOpened => !isOpened);
    }

    const editStory = (userStory) => {
        props.editUserStory(true, userStory, props.header_data, 'edit');
    }

    const showStoryTasksInBoard = (userStoryId) => {
        let data = {
            masterProjectId,
            masterReleaseId,
            masterUserId: props.header_data.masterUserId,
            userStoryId: userStoryId || 0,
            filterStartDate: props.header_data.filterStartDate,
            filterEndDate: props.header_data.filterEndDate
        };

        trackPromise(
            getTaskList(dispatch,applicationId, siteId, data, storedToken)
                .then((response) => {
                    if (response?.taskDetails?.length) {
                        toast.success('Task list fetched successfully!', { position: toast.POSITION.TOP_RIGHT });
                        props.hideUserStoryList(false, userStoryId, props.header_data, 'showTask');
                    } else {
                        toast.warning('No record found!', { position: toast.POSITION.TOP_RIGHT });
                    }
                })
                .catch(console.error)
        );
    }

    const sortStoryEnd = async (order) => {
        if (!order.item) return;
        var selectElement = $(order.item);
        var prev = selectElement.prev().data("priority");
        var next = selectElement.next().data("priority");
        var priority = prev === undefined ? 1 : next === undefined ? Math.min(prev + 1, 5) : prev + 1;

        var newState = [...userStories];
        newState[order.newIndex].userStoryTO.priority = priority;
        setUserStories(newState);

        var formData = new FormData();
        formData.append('userstoryid', newState[order.newIndex].userStoryTO.userStoryId);
        formData.append('priority', priority);
        formData.append('applicationid', applicationId);
        formData.append('siteid', siteId);
        formData.append('userid', commonParams.userid);
        formData.append('swcmTicket', commonParams.swcmTicket);

        await customFormDataPost(apiUrls.updateStoryPriority, formData, storedToken);
    }

    return (
        <div className="form-sec shadow-lg add-form-sec-left">
            <div className="form-blog w-100 float-left position-relative" style={{ overflowX: 'auto' }}>
                <span onClick={() => props.hideUserStoryList(false, null)} className="close-form-icon">
                    <i className="fa fa-times" aria-hidden="true"></i>
                </span>
                <h2>User Story List</h2>
                <div id="sortStory" className="w-100 float-left pl-2 pr-2">
                    <ReactSortable list={userStories} setList={setUserStories} animation={150} onEnd={sortStoryEnd}>
                        {userStories.map(story => (
                            <div key={story.userStoryTO.userStoryId} style={{ backgroundColor: story.userStoryTO.colorCode }} data-priority={story.userStoryTO.priority} className="w-100 float-left block shadow-sm storyBox">
                                <div className="block-box w-100 float-left position-relative">
                                    <div className="heading-tp-left show-hide-task" onClick={toggleStoryTasks}>
                                        <span className="float-left">{story.userStoryTO.title}</span>
                                        <span className="float-right" style={{ color: story.userStoryTO.colorCode }}>{story.userStoryTO.priority}</span>
                                    </div>
                                    <div className="my-1 w-100 float-left task-details-collapse">
                                        <div className="cmt-box w-100 float-left">
                                            <div className="open-task border-bottom w-100 float-left pb-1 mb-1">
                                                <p className="font-14 pb-1"><strong className="time red-clr">Open tasks</strong></p>
                                                {story.taskList.filter(t => t.status.toLowerCase() !== "accepted").length > 0
                                                    ? story.taskList.filter(t => t.status.toLowerCase() !== "accepted").map(task => (
                                                        <p key={task.taskId} className="w-100 float-left p-btm-1">
                                                            <span className="float-left"><strong className="time">{task.title} : </strong>{task.description}</span>
                                                            <span className="float-right">
                                                                <Link to={"/dashboard?t=" + task.taskId} className="btn btn-sm btn-light border border-dark py-0 px-1" target="_blank">
                                                                    <small>View</small>
                                                                </Link>
                                                            </span>
                                                        </p>
                                                    )) : <p>No record found.</p>
                                                }
                                            </div>
                                            <div className="closed-task w-100 float-left">
                                                <p className="font-14 pb-1"><strong className="time red-clr">Closed tasks</strong></p>
                                                {story.taskList.filter(t => t.status.toLowerCase() === "accepted").length > 0
                                                    ? story.taskList.filter(t => t.status.toLowerCase() === "accepted").map(task => (
                                                        <p key={task.taskId} className="w-100 float-left p-btm-1">
                                                            <span className="float-left"><strong className="time">{task.title} : </strong>{task.description}</span>
                                                            <span className="float-right">
                                                                <Link to={"/dashboard?t=" + task.taskId} className="btn btn-sm btn-light border border-dark py-0 px-1" target="_blank">
                                                                    <small>View</small>
                                                                </Link>
                                                            </span>
                                                        </p>
                                                    )) : <p>No record found.</p>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="assignee w-100 float-left">
                                        <button type="button" onClick={() => editStory(story)} className="btn btn-sm btn-light border-dark mr-1"><small>Edit</small></button>
                                        <button type="button" onClick={() => showStoryTasksInBoard(story.userStoryTO.userStoryId)} className="btn btn-sm btn-light border-dark"><small>Show Task</small></button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </ReactSortable>
                </div>
                <p className="text-center">{userStories.length === 0 && 'No record found!'}</p>
            </div>
        </div>
    )
}

export default UserStory;
